<template>
    <div class="d-flex align-items-center flex-shrink-0">
        <UserDropdown />
        <NotificationDropdown
            :reload="reload"
            @reset="reset"
            @showNotifier="showNotifier"
        />
    </div>
</template>

<script>
import NotificationDropdown from "@/components/NotificationDropdown.vue";
import UserDropdown from "@/components/UserDropdown.vue";
import Vue from "vue";

    export default Vue.extend({
        components:{
            NotificationDropdown,
            UserDropdown
        },
        props: {
            reload: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data() {
            return {
            }
        },
        methods: {
            reset(e){
                this.$emit('reset', e);
            },
            showNotifier(e){
                this.$emit('showNotifier', e);
            }
        },
    });
</script>

<style lang="scss" scoped>

</style>